import CznSaveDataCalculator from './CznSaveDataCalculator';

function App() {
  return <CznSaveDataCalculator />;
}

export default App;
